import { Link } from "react-router-dom";
import { useLang } from "@/lib/i18n";

const renderBold = (text, key) =>
  text.split(/(\*\*[^*]+\*\*)/g).map((part, i) =>
    part.startsWith("**") && part.endsWith("**") ? <strong key={`${key}-${i}`}>{part.slice(2, -2)}</strong> : part
  );

const inline = (text, to) =>
  text.split(/(\[[^\]]+\]\([^)\s]+\))/g).map((part, i) => {
    const m = part.match(/^\[([^\]]+)\]\(([^)\s]+)\)$/);
    if (!m) return renderBold(part, i);
    return m[2].startsWith("/")
      ? <Link key={i} to={to(m[2])} className="font-bold text-forest underline underline-offset-4">{m[1]}</Link>
      : <a key={i} href={m[2]} target="_blank" rel="noreferrer" className="font-bold text-forest underline underline-offset-4">{m[1]}</a>;
  });

export const RichText = ({ text = "" }) => {
  const { to } = useLang();
  const blocks = text.split(/\n\s*\n/).filter(Boolean);
  const out = [];
  blocks.forEach((block, bi) => {
    const lines = block.split("\n");
    let bullets = [];
    let para = [];
    const flush = () => {
      if (para.length) out.push(<p key={`p${bi}-${out.length}`}>{inline(para.join(" "), to)}</p>);
      if (bullets.length) out.push(<ul key={`u${bi}-${out.length}`}>{bullets.map((b, i) => <li key={i}>{inline(b, to)}</li>)}</ul>);
      para = [];
      bullets = [];
    };
    lines.forEach((line) => {
      const l = line.trim();
      const im = l.match(/^!\[([^\]]*)\]\(([^)\s]+)\)$/);
      if (im) {
        flush();
        out.push(<img key={`i${bi}-${out.length}`} src={im[2]} alt={im[1]} loading="lazy" className="my-8 w-full rounded-2xl object-cover" />);
      } else if (l.startsWith("## ")) {
        flush();
        out.push(<h2 key={`h${bi}-${out.length}`}>{l.slice(3)}</h2>);
      } else if (l.startsWith("- ")) {
        if (para.length) flush();
        bullets.push(l.slice(2));
      } else if (l) {
        if (bullets.length) flush();
        para.push(l);
      }
    });
    flush();
  });
  return <div className="rich" data-testid="rich-text">{out}</div>;
};
